// Access token lives in memory only (cleared on reload) so a compromised
// dependency cannot read it from web storage. Refresh token lives in
// sessionStorage so it is per-tab and cleared when the tab closes.
//
// The proper XSS-proof home for the refresh token is an httpOnly + Secure +
// SameSite=Strict cookie set by the backend. Until the API supports that,
// sessionStorage reduces blast radius versus localStorage but an injected
// script on the same origin can still read it.

const REFRESH_TOKEN_KEY = 'abetting_refresh_token'

let accessToken: string | null = null
const listeners = new Set<() => void>()

const notify = () => {
  listeners.forEach((listener) => listener())
}

export const tokenStorage = {
  getAccessToken(): string | null {
    return accessToken
  },
  getRefreshToken(): string | null {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY)
  },
  setTokens(newAccessToken: string, newRefreshToken?: string): void {
    accessToken = newAccessToken
    if (newRefreshToken) {
      sessionStorage.setItem(REFRESH_TOKEN_KEY, newRefreshToken)
    }
    notify()
  },
  clear(): void {
    accessToken = null
    sessionStorage.removeItem(REFRESH_TOKEN_KEY)
    notify()
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
}